<template>
  <div class="contents meijisyo">
    <h2>就業条件明示書</h2>

    <div class="container meijisyo-detail">
      <meijisyo-detail></meijisyo-detail>
    </div>

  </div><!--contents-->
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MeijisyoDetail from '@/components/meijisyo/Detail.vue';
import { RouterConst } from '@/const/Router';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    const route = useRoute()
    const keiyakuId = parseInt(route.params.id as string, 10)
    return {
      RouterConst,
      keiyakuId
    }
  },
  components: {
    'meijisyo-detail': MeijisyoDetail,
  }
})

</script>

<style scoped lang="scss">
@media print {
  .contents>h2 {
    color: $colorFont;
  }
}
</style>